<form class="mce-form-section">

    <div class="mce-form-section-title">Fault Source</div>


    @for(source of form().faultSource.sources; track $index) {


    <div class="mce-form-field-group">

        <div class="mce-form-section-title-sub">
            {{$index === 0 ? 'Short Circuit:' : 'Earth Fault:'}}
        </div>


        <div class="flex flex-col">

            <div class="mce-form-field-group">
                <div [class.mce-form-field-disabled]="viewState().disableImpedance">
                    <mat-form-field>
                        <mat-label>source resistance</mat-label>
                        <input matInput type="number" placeholder="source resistance"
                               [formField]="source.r" />
                        <span matSuffix>Ω</span>
                        @for (error of source.r().errors(); track error.kind ) {
                        <mat-error> {{ error.message }} </mat-error> }
                    </mat-form-field>
                </div>

                @if(!viewState().isDC) {
                <div [class.mce-form-field-disabled]="viewState().disableImpedance">
                    <mat-form-field>
                        <mat-label>source reactance</mat-label>
                        <input matInput type="number" placeholder="source reactance"
                               [formField]="source.x" />
                        <span matSuffix>Ω</span>
                        @for (error of source.x().errors(); track error.kind ) {
                        <mat-error> {{ error.message }} </mat-error> }
                    </mat-form-field>
                </div>
                }

            </div>

        </div>

        <div>
            <mat-form-field>
                <mat-label>clearance time</mat-label>
                <input matInput type="number" placeholder="clearance time"
                       [formField]="source.clearanceTime" />
                <span matSuffix>s</span>
                @for (error of source.clearanceTime().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


    </div>

    }


    <mce-info-message [type]="'information'">
        <div class="flex flex-col gap-2">
            @for(source of faultLevels(); track $index) {
            <div>

                <button mat-button type="button" color="primary" (click)="$index === 0 ? onClickSc() : onClickEf()">
                    <mat-icon>edit</mat-icon>
                    {{$index === 0 ? 'Short Circuit:' : 'Earth Fault:'}}
                    kA: {{viewState().loading? 'loading...' : (source.i| number:'1.0-3')}}
                    @if(!viewState().isDC) {
                    pf: {{viewState().loading? 'loading...' : (source.pf.pf | number:'1.0-2') }} {{source.pf.lagging ? 'lagging' : 'leading'}}


                    }
                </button>

                @if(!viewState().isDC) {
                |
                <button mat-button type="button" color="primary" (click)="$index === 0 ? onClickScZe() : onClickEfZe()">
                    <mat-icon>edit</mat-icon>
                    Ze: {{viewState().loading ? 'loading...' : (source.z | number:'1.0-3')}} Ω
                    X/R: {{viewState().loading ? 'loading...' : (source.xrRatio === undefined ? 'N/A' : (source.xrRatio | number:'1.0-2'))}}
                </button>
                }

            </div>
            }
        </div>
    </mce-info-message>


    <app-calculation-box [status]="viewState().status" [loading]="viewState().loading">

        @let endFault = $safeNavigationMigration(cableFault()?.cableEndFault);
        @let withStand = $safeNavigationMigration(cableFault()?.cableWithstand);


        <div class="calculation-box-content">

            <div>
                cable end short-circuit:
                {{$safeNavigationMigration(endFault?.shortCircuitMax?.i) | number:'0.0-0' }}/{{$safeNavigationMigration(endFault?.shortCircuitMin?.i) | number:'0.0-0'}} A
                @if(cableFault()?.case === "ac1ph" || cableFault()?.case === "ac3ph"){
                pf: {{$safeNavigationMigration(endFault?.shortCircuitMax?.pf?.pf) | number:'0.0-2'}} [{{endFault?.shortCircuitMax?.pf?.lagging ? 'lagging' : 'leading'}}]
                }
            </div>

            <div>
                cable end earth-fault:
                {{$safeNavigationMigration(endFault?.earthFaultMax?.i) | number:'0.0-0' }}/{{$safeNavigationMigration(endFault?.earthFaultMin?.i) | number:'0.0-0'}} A
                @if(cableFault()?.case === "ac1ph" || cableFault()?.case === "ac3ph"){
                pf: {{$safeNavigationMigration(endFault?.earthFaultMax?.pf?.pf) | number:'0.0-2'}} [{{endFault?.earthFaultMax?.pf?.lagging ? 'lagging' : 'leading'}}]
                }
            </div>

        </div>


        <div class="calculation-box-content">

            <div>
                short-circuit I<sup>2</sup>t  {{$safeNavigationMigration(withStand?.shortCircuitI2t) | number:'0.0-0'}} A<sup>2</sup>s
            </div>

            <div>
                earth-fault I<sup>2</sup>t {{$safeNavigationMigration(withStand?.earthFaultI2t) | number:'0.0-0'}} A<sup>2</sup>s
            </div>

            <div>
                cable withstand I<sup>2</sup>t {{$safeNavigationMigration(withStand?.cableWithstandI2t) | number:'0.0-0'}} A<sup>2</sup>s
            </div>

        </div>


        <div class="calculation-box-content">
            <div>
                cable rating:
                1s {{(withStand?.cableRating1s ?? 0) / 1000 | number:'1.0-1'}} kA;
                3s {{(withStand?.cableRating3s ?? 0) / 1000 | number:'1.0-1'}} kA;
            </div>
        </div>

    </app-calculation-box>


</form>
